export enum OperatorNodeType {
  binary = 'binary',
  unary = 'unary'
}

export enum ComputationNodeType {
  operator,
  operand
}

export enum ComputationBinaryOperators {
  add,
  subtract,
  multiply,
  divide,
  exponent,
  start_bracket,
  close_bracket,
  ceil,
  floor,
  abs
}

export enum ComputationNodeSubtype {
  constant = 0,
  variable = 1,
  item_quantity = 2,
  days_computation = 3,
  item_exists = 4,
  item_tag_quantity = 5,
  item_tag_exists = 6,
  item_tag_machine_quantity = 7
}

export enum ComputationBinaryOperatorsSymbols {
  add = '+',
  subtract = '-',
  multiply = '*',
  divide = '/',
  ceil = 'ceil'
}

export interface IQuoteServiceVariableData {
  id?: number;
  name: string;
  value: string; //should be number not decimal field
  /**
   * @see {@link quotes.QuoteServiceTemplate}
   * link to a quote service template
   */
  service: null | number; // ServiceTemplate
}

export interface IServiceComputationNodeData {
  id?: number;
  order?: number;
  /**
   * @see {@link ComputationNodeType}
   * type of computation node
   */
  type: number;
  /**
   * @see {@link ComputationBinaryOperators}
   * @see {@link ComputationNodeSubtype}
   *
   * operator value should be the type of an arithmetic operation
   */
  subtype?: number;
  constant?: number | null;
  days_computation?: number | null;
  items?: string[];
  /**
   * @see {@link IQuoteServiceVariable}
   * variable should a foreign key link to
   */
  variable?: number | null;
  /**
   * @see {@link ITag}
   * gets related items linked to tags
   */
  item_tags?: number[];
}

export type ExpressionNodeTree = (
  | IServiceComputationNode
  | ExpressionNodeTree
)[];

export interface IServiceComputationNode extends IServiceComputationNodeData {
  index?: number;

  validate(): boolean;

  isOperand(): boolean;
  isOperator(): boolean;

  isStartBracket(): boolean;
  isCloseBracket(): boolean;
  isUnaryOperator(): boolean;

  toString(): string;
}

export interface IServicePriceComputationData {
  id?: number;
  description?: string;
  nodes: IServiceComputationNodeData[];
}

export interface IServicePriceComputation extends IServicePriceComputationData {
  nodes: IServiceComputationNode[];
  validate(): boolean;

  toExpressionTree(): ExpressionNodeTree;
  toNodeList(tree: ExpressionNodeTree): IServiceComputationNode[];
}

export interface IServiceComputationNode extends IServiceComputationNodeData {
  validate(): boolean;
}

export interface IQuoteServiceVariable extends IQuoteServiceVariableData {
  validate(): boolean;
}

// Field Errors
export interface IQuoteServiceVariableFieldErrorData {
  name: string[];
  value: string[];
}

export interface IQuoteServiceVariableFieldError
  extends IQuoteServiceVariableFieldErrorData {
  clearErrors(): void;
}
export interface IServiceComputationNodeFieldErrorData {
  order?: string[];
  type?: string[];
  subtype?: string[];
  constant?: string[];
  question?: string[];
  items?: string[];
  variable?: string[];
  days_computation?: string[];
  item_tags?: string[];
}

export interface IServiceComputationFieldErrorData {
  description?: string[];
  nodes?: IServiceComputationNodeFieldErrorData[];
}

export interface IServiceComputationNodeFieldError
  extends IServiceComputationNodeFieldErrorData {
  clearErrors(): void;
}

export interface IServiceComputationFieldError
  extends IServiceComputationFieldErrorData {
  nodes?: IServiceComputationNodeFieldError[];
  clearErrors(): void;
}
